module.exports = __webpack_public_path__ + "assets/images/premium-features/unavailability-banner-new-08f48a.png";